var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5C10.5 4.22386 10.2761 4 10 4C9.72386 4 9.5 4.22386 9.5 4.5V14.197L5.87165 10.1655C5.68692 9.96026 5.37078 9.94362 5.16552 10.1284C4.96027 10.3131 4.94363 10.6292 5.12836 10.8345L9.62836 15.8345C9.72318 15.9398 9.85826 16 10 16C10.1417 16 10.2768 15.9398 10.3717 15.8345L14.8717 10.8345C15.0564 10.6292 15.0397 10.3131 14.8345 10.1284C14.6292 9.94362 14.3131 9.96026 14.1284 10.1655L10.5 14.197V4.5Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7298905c7707012ec47f3cfedc40dae5.svg";
export { ForwardRef as ReactComponent };